import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Item, Table} from "semantic-ui-react";
import {Zone} from "../../../../models/grundstueck";
import SVG from "react-inlinesvg";
import {MapViewerStore} from "../../../../stores/map-viewer-store-mobx";
import {withStore} from "../../../../core/stores/abstract-app-store";

export interface ZonenTableProps {
    data: Zone[];
    highlightedItemId: string | null;
    handleHighlightClick: (e: React.MouseEvent | undefined, zone: Zone | null) => void;
    link?: React.ReactElement;
    title?: string;
    store?: MapViewerStore; // this is injected by withStore
}
interface SortAction {
    type: string;
    column: string;
}
@observer
class ZonenTableBase extends Component<ZonenTableProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    constructor(props: ZonenTableProps) {
        super(props);
        this.state = {
            column: "grundnutzung",
            data: _.orderBy(this.props.data, ["grundnutzung"], ["asc"]),
            direction: "ascending"
        };
        this.sort = this.sort.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState({
                    ...this.state,
                    data: this.state.data.reverse(),
                    direction:
                            this.state.direction === "ascending" ? "descending" : "ascending"
                });
            } else {
                this.setState({
                    column: action.column,
                    data: _.sortBy(this.state.data, [action.column]),
                    direction: "ascending",
                });
            }
            return;
        default:
            throw new Error();
        }
    }
    handleHighlightClick(e: React.MouseEvent, zone: Zone): void {
        const { highlightedItemId } = this.props;
        if (zone.itemId === highlightedItemId){
            this.props.handleHighlightClick(e, null);
        } else {
            this.props.handleHighlightClick(e, zone);
        }
    }
    componentDidMount(): void {
        const { store } = this.props;
        store?.oStore.loadZonenplan().then(() => {
            this.setState({
                data: this.state.data.map((item: Zone) => {
                    item.preview = store?.oStore.getZonenplanPreview(item.typeGemeinde) as string;
                    return item;
                })
            });
        });
    }

    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
    }
    render(): React.ReactElement | null {
        const { column, data, direction } = this.state;
        const { highlightedItemId, link } = this.props;
        if (data === null || data.length === 0){
            return null;
        }
        let title: string;
        if (this.props.title) {
            title = this.props.title;
        } else {
            title = "Grundnutzung Zonenplan";
        }
        // const center = this.props.mapStore.view.center;
        // gravisUrl = gravisAction.url + "PARCEL=" + feature.attributes.GBPER_CODE + "." +  feature.nummer
        //    + "&Suche.Gemeinde=" + feature.attributes.BFS_NR
        //    + "&FOCUS=" + center.x + ":" + center.y + ":" + this.props.mapStore.view.scale;
        return (
            <Item className={"geo-zonenplan-item"}><Item.Content><Item.Header as="h3">{title}</Item.Header>
                <Table basic="very" sortable={(data.length > 1)} compact className={"zonenplan"}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={2} singleLine
                                sorted={column === "grundnutzung" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "grundnutzung" })}>
                            Zonentyp Kanton</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                sorted={column === "bezeichnung" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "bezeichnung" })}>
                            Zonentyp Gemeinde</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                textAlign="right"
                                className={"number"}
                                sorted={column === "flaeche" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "flaeche" })}>
                            Fläche</Table.HeaderCell>
                            <Table.HeaderCell singleLine
                                textAlign="right"
                                className={"number"}
                                sorted={column === "anteil" ? direction : null}
                                onClick={() => this.sort({ type: "CHANGE_SORT", column: "anteil" })}>
                            Anteil</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data.map((zone: Zone) => (
                            <Table.Row key={zone.type}
                                className={((zone.itemId === highlightedItemId) ? "highlighted" : "")}
                                onClick={(event: React.MouseEvent) => this.handleHighlightClick(event, zone)}>
                                <Table.Cell>{zone.preview? (<SVG src={zone.preview} />): ""}</Table.Cell>
                                <Table.Cell>{zone.grundnutzung}</Table.Cell>
                                <Table.Cell>{zone.bezeichnung}</Table.Cell>
                                <Table.Cell textAlign="right">
                                    {new Intl.NumberFormat("de-CH").format(Math.round(zone.flaeche))} m²</Table.Cell>
                                <Table.Cell textAlign="right">{
                                    (zone.anteil < 1) ? "< 1" : Math.round(zone.anteil)}%</Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body></Table>
                <small>
                    <em>Kleinstflächen werden nicht angegeben. Minimale Abweichungen zu Grundstückfläche möglich.</em>
                </small>
                <div className={"geo-zonen-link"}>{link}</div>
            </Item.Content></Item>
        );
    }
}

export const ZonenTable = withStore(ZonenTableBase);
